/* ==========================================================================
   NOVOLOGY PRESS RELEASE JS ENGINE
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {

  // 1. PROGRESSIVE ENHANCEMENT: SIGNAL JS ACTIVE STATUS
  document.body.classList.add('js-active');

  // 2. MOBILE MENU TOGGLE
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const desktopNav = document.querySelector('.desktop-nav');
  
  if (menuToggle && desktopNav) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('active');
      desktopNav.classList.toggle('mobile-active');
    });
  }

  // 3. SCROLL ENTRANCE ANIMATIONS (WITH ROBUST ERROR PROTECTION)
  try {
    const animElements = document.querySelectorAll('.scroll-animate');

    const animObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -20px 0px'
    });

    animElements.forEach(el => {
      animObserver.observe(el);
    });
  } catch (error) {
    console.warn("IntersectionObserver failed to initialize. Falling back to instant visibility.", error);
    
    // Force active classes immediately if IntersectionObserver fails (SEO crawlers)
    const animElements = document.querySelectorAll('.scroll-animate');
    animElements.forEach(el => {
      el.classList.add('animated');
    });
  }
});
